import { FinancialConvo, FinancialConvoJSON } from "../models/FinancialConvo";
import { callDelete, callGet, callPost, callPut, } from "./index";

export class FinancialConvoAPI {
  async fetchRequests(
    estateId: number,
    userId: number,
    includeDeleted = false,
    includeCompleted = false
  ): Promise<FinancialConvo[] | undefined> {
    try {
      const pathParams = [];
      let path = `estates/${estateId}/users/${userId}/financial-convos`

      if (includeDeleted) pathParams.push("deleted=true");
      if (includeCompleted) pathParams.push("completed=true");
      if (pathParams.length > 0) {
        const pathParamsString = pathParams.join("&");
        path += `?${pathParamsString}`;
      }

      const response = await callGet(path);
      // an empty array of estates is a legitimate response
      return (
        response?.data?.map((json: any) => FinancialConvo.fromJSON(json)) || []
      );
    } catch (error) {
      console.error(error, "fetchRequests error");
    }
    return undefined;
  }

  async fetchSingleRequest(
    estateId: number,
    userId: number,
    requestId: number
  ): Promise<FinancialConvo | undefined> {
    try {
      const response = await callGet(
        `estates/${estateId}/users/${userId}/financial-convos/${requestId}`,
        true
      );
      return FinancialConvo.fromJSON(response?.data);
    } catch (error) {
      console.error(error, "fetchSingleRequest error");
    }
    return undefined;
  }

  async fetchLatestRequest(
    estateId: number,
    userId: number,
    includeDeleted = false,
    includeCompleted = false
  ): Promise<FinancialConvo | undefined> {
    try {
      let path = `estates/${estateId}/users/${userId}/financial-convos-latest`;
      const pathParams = [];
      if (includeDeleted) pathParams.push("deleted=true");
      if (includeCompleted) pathParams.push("completed=true");

      if (pathParams.length > 0) {
        const pathParamsString = pathParams.join("&");
        path += `?${pathParamsString}`;
      }

      const response = await callGet(path, true);
      return FinancialConvo.fromJSON(response?.data) || undefined;
    } catch (error) {
      // // console.error(error, "fetchSingleRequest error");
      // const axiosError = error as AxiosError;
      // if (axios(error as any)?.response?.status === 404) {
      //   // Do nothing.
      // } else if (axios(error as any)?.response?.status === 401) {
      //   // TODO: Error handling for auto
      //   console.error(
      //     `401 : ${axios(error as any)?.response?.statusText}` ||
      //       "fetchLatestRequest error"
      //   );
      // } else {
      //   console.error(
      //     `OTHER : ${axios(error as any)?.response?.statusText}` ||
      //       "fetchLatestRequest error"
      //   );
      // }
    }
    return undefined;
  }

  async createRequest(estateId: number, userId: number, initialFields: FinancialConvoJSON): Promise<number> {
    try {
      const response = await callPost(
        `estates/${estateId}/users/${userId}/financial-convos`,
        initialFields
      );
      return response?.data?.id;
    } catch (error) {
      console.error(error, "createRequest error");
      throw error;
    }
  }

  async submitRequest(estateId: number, userId: number, id: number): Promise<any> {
    try {
      const response = await callPost(
        `estates/${estateId}/users/${userId}/financial-convos/submit/${id}`
      );
      return response;
    } catch (error) {
      console.error(error, "submitRequest error");
      throw error;
    }
  }

  async checkRequestSubmit(estateId: number, userId: number, id: number): Promise<boolean> {
    try {
      const response = await callPost(
        `estates/${estateId}/users/${userId}/financial-convos/submission-status/${id}`
      );
      return response?.data;
    } catch (error) {
      console.error(error, "checkRequestSubmit error");
      throw error;
    }
  }

  async updateRequest(
    estateId: number,
    userId: number,
    id: number,
    updateFields: FinancialConvoJSON
  ): Promise<boolean> {
    try {
      await callPut(`estates/${estateId}/users/${userId}/financial-convos/${id}`, updateFields);
      return true;
    } catch (error) {
      console.error(error, "updateRequest error");
      throw error;
    }
  }

  async deleteRequest(estateId: number, userId: number, id: number): Promise<boolean> {
    try {
      await callDelete(`estates/${estateId}/users/${userId}/financial-convos/${id}`);
      return true;
    } catch (error) {
      console.error(error, "deleteRequest error");
      throw error;
    }
  }
}
